module.exports = __webpack_public_path__ + "static/media/bang2.a64acd29.mp3";